/**
 * useIsProjectOwner
 * Centralized logic for determining if the current user is a project owner.
 * Project owners have level 0 and a user_system_id (top-level account).
 *
 * Used for billing features: Manage Billing, Upgrade to Pro, Past Due banner.
 * Extracting here ensures a single source of truth if the definition changes.
 */

import { useUserStore } from "@finitless/shared/stores";

/**
 * @returns {boolean} True when user is a project owner (level 0 + user_system_id)
 */
export const useIsProjectOwner = () => {
  const user = useUserStore((state) => state.user);
  return user?.level === 0 && !!user?.user_system_id;
};
